import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import {OrderedSet} from 'immutable';

import * as FeedItemActions from 'web-app/react/entities/feed/items/actions';

import postsReducer from './post/reducer';
import newPostReducer from './post/new-post/reducer';
import switchReducer from './feed-switcher/reducer';
import draftManagerReducer from './drafts/reducer';
import * as Actions from './actions';

const itemIdsReducer = handleActions(
    {
        [FeedItemActions.deleteItemSuccess.type]: (state, {payload}) => state.filter(id => id !== payload.feedItemId),
        [Actions.clearState.type]: () => new OrderedSet(),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            payload.reload ? OrderedSet(payload.feedItemIds) : state.concat(OrderedSet(payload.feedItemIds)),
    },
    new OrderedSet(),
);

const showingFeedReducer = handleActions(
    {
        [Actions.showingFeed.type]: (state, {payload}) => payload.show,
    },
    false,
);

const fetching = handleActions(
    {
        [Actions.fetch.type]: () => true,
        [Actions.fetchSuccess.type]: () => false,
        [Actions.fetchFailed.type]: () => false,
    },
    false,
);

const reloading = handleActions(
    {
        [Actions.fetch.type]: (state, {payload}) => payload.reload && !payload.resolve,
        [Actions.fetchSuccess.type]: () => false,
        [Actions.fetchFailed.type]: () => false,
    },
    false,
);

const justFetchedInitial = handleActions(
    {[Actions.fetch.type]: (state, {payload}) => Boolean(payload.initialFetch)},
    false,
);

const hasMore = handleActions(
    {
        [Actions.fetchSuccess.type]: (_, {payload}) => payload.feedItemIds.size > 0,
        [Actions.fetchFailed.type]: () => false,
    },
    false,
);

const focusMode = handleActions(
    {
        [Actions.focusModeSuccess.type]: (_, {payload}) => payload.isFocused,
    },
    false,
);

const feedReducer = combineReducers({
    focusMode,
    fetching,
    reloading,
    hasMore,
    showingFeed: showingFeedReducer,
    itemIds: itemIdsReducer,
    draftManager: draftManagerReducer,
    newPost: newPostReducer,
    posts: postsReducer,
    switcher: switchReducer,
    justFetchedInitial,
});

export default feedReducer;
